import 'react-tabs/style/react-tabs.scss';
import { AppContext } from '../../context/AppContext';
import { Formik, Field } from 'formik';
import { scroller, Element } from 'react-scroll';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { validationSchema } from '../../form/ValidationSchema';
import AlertMessage from '../modal/AlertMessage';
import AudienceTab from '../tab/AudienceTab';
import classNames from 'classnames';
import ContactTab from '../tab/ContactTab';
import DetailTab from '../tab/DetailTab';
import InfoForm from '../modal/InfoForm';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import React, { Component } from 'react'
import RequiredSpan from '../form/base/RequiredSpan';
import ServiceTab from '../tab/ServiceTab';
import VisitorTab from '../tab/VisitorTab';
import axios from 'axios';
import { config } from '../../config';
import { DrupalService } from '../../helper/DrupalService';

Modal.setAppElement('#org_pub_form_root');

class MainPage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    // set states
    this.state = {
      activeTab: -1,
      tabDisabled: [true, true, true, true, true],
      submitted: false,
      id: 0
    };

    this.goToNextTab = this.goToNextTab.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
    this.invalidHandler = this.invalidHandler.bind(this);
  }

  componentDidMount() {
    this.goToTab(0);
  }

  async submitHandler(values) {
    const token = await DrupalService.getToken();

    axios.post(config.API_DOMAIN + '/npin_organization_submit?_format=json', values, {
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        'x-csrf-token': token,
      },
    }).then(response => {
      if (response.data.success) {
        this.setState({
          submitted: true,
          id: response.data.id,
        });
      } else {
        this.context.modifyAlert(AlertMessage.TYPE_ERROR, response.data.message);
        this.context.showAlert();
      }
    }).catch(error => {
      console.log(error);
      this.context.modifyAlert(AlertMessage.TYPE_ERROR, 'Failed to submit your organization. Please try again later.');
      this.context.showAlert();
    });
  }

  invalidHandler(errors) {
    this.goToInvalidElement(errors);
  }

  goToInvalidElement(errors) {
    if (Object.keys(errors).length === 0) {
      return;
    }

    const names = Object.keys(errors);
    const tabsName = [
      [
        'organization_name_1',
        'address_street1',
        'address_zip',
        'phones',
      ],
      [
        'contact_pri_first_name',
        'contact_pri_last_name',
        'contact_pri_email',
        'contact_pri_phone_number',
        'contact_sec_phone_number'
      ],
      [
        'support_services',
        'testing_services',
        'prevention_services',
        'care_and_treatment_services',
        'offer_self_testing',
      ],
      [
        'audiences',
        'languages',
      ],
      [
        'contact_hours',
        'fees',
        'token',
      ],
    ];

    // switch to the tab where the invalid element is in
    let invalidElementName = null;
    outside:
    for (let i = 0; i < tabsName.length; i++) {
      for (let j = 0; j < tabsName[i].length; j++) {
        if (names.indexOf(tabsName[i][j]) !== -1) {
          invalidElementName = tabsName[i][j];
          this.goToTab(i);
          break outside;
        }
      }
    }

    //scroll to the invalid element
    if (invalidElementName) {
      setTimeout(() => {
        scroller.scrollTo(invalidElementName, {
          duration: 500,
          smooth: true,
          offset: -50
        });
      }, 250);
    }
  }

  goToNextTab() {
    this.goToTab(this.state.activeTab + 1, true);
  }

  goToTab(index, scrollToTop = false) {
    if (this.state.activeTab !== index) {
      this.setState({ activeTab: index });

      if (scrollToTop) {
        scroller.scrollTo("org-form-top", {
          duration: 500,
          smooth: true
        });
      }

      let tabDisabled = this.state.tabDisabled;
      tabDisabled[index] = false;
      if (index + 1 < tabDisabled.length) {
        tabDisabled[index + 1] = false;
      }
      this.setState({ tabDisabled: tabDisabled });
    }
  }

  render() {
    if (this.state.submitted) {
      return <div className="submission-message">Thank you for your submission. Your submission ID is
        #{this.state.id}</div>
    }

    return (
      <div className={'form-wrapper'}>
        <Element name="org-form-top"></Element>
        <Formik
          initialValues={this.props.formValue}
          validationSchema={validationSchema}
          onSubmit={this.submitHandler}>
          {({ isValid, dirty, errors, values }) => (
            <form onSubmit={(e) => {
              e.preventDefault();

              if (dirty && isValid) {
                this.submitHandler(values);
              } else {
                this.invalidHandler(errors);
              }
            }}>
              <Field type="hidden" name="id" />
              <Tabs selectedIndex={this.state.activeTab}
                onSelect={index => this.goToTab(index)}>
                <TabList>
                  <Tab disabled={this.state.tabDisabled[0]}>Organization Details<RequiredSpan /></Tab>
                  <Tab disabled={this.state.tabDisabled[1]}>Contacts<RequiredSpan /></Tab>
                  <Tab disabled={this.state.tabDisabled[2]}>Services<RequiredSpan /></Tab>
                  <Tab disabled={this.state.tabDisabled[3]}>Audiences<RequiredSpan /></Tab>
                  <Tab disabled={this.state.tabDisabled[4]}>Visitor Information<RequiredSpan /></Tab>
                </TabList>

                <TabPanel className={classNames(['react-tabs__tab-panel', 'tab-organization-detail'])}>
                  <DetailTab formData={this.props.formData} nextTab={this.goToNextTab} />
                </TabPanel>
                <TabPanel className={classNames(['react-tabs__tab-panel', 'tab-organization-contact'])}>
                  <ContactTab nextTab={this.goToNextTab} />
                </TabPanel>
                <TabPanel className={classNames(['react-tabs__tab-panel', 'tab-organization-services'])}>
                  <ServiceTab formData={this.props.formData} nextTab={this.goToNextTab} />
                </TabPanel>
                <TabPanel className={classNames(['react-tabs__tab-panel', 'tab-organization-audiences'])}>
                  <AudienceTab formData={this.props.formData} nextTab={this.goToNextTab} />
                </TabPanel>
                <TabPanel className={classNames(['react-tabs__tab-panel', 'tab-organization-visitor'])}>
                  <VisitorTab formData={this.props.formData} submit={this.handleSubmit} />
                </TabPanel>
              </Tabs>
              <InfoForm
                open={this.context.info.show}
                entity={this.props.formValue} />
            </form>
          )}
        </Formik>
        <AlertMessage
          show={this.context.alert.show}
          type={this.context.alert.type}
          message={this.context.alert.message}
          hide={this.context.hideAlert} />
      </div>
    );
  }
}

MainPage.propTypes = {
  formData: PropTypes.object,
  formValue: PropTypes.object,
}

MainPage.defaultProps = {
  formData: {},
  formValue: {},
}

export default MainPage;
